import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { allApis } from 'service/api/allApis';

interface IBookmarksState {
    bookmarks: number[];
}

const initialState: IBookmarksState = {
    bookmarks: localStorage.getItem('bookmarks')
        ? JSON.parse(localStorage.getItem('bookmarks') as string)
        : [],
};

export const bookmarksSlice = createSlice({
    initialState,
    name: 'bookmarksSlice',
    reducers: {
        addBookmark: (state, action: PayloadAction<number>) => {
            state.bookmarks.push(action.payload);
            localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
        },
        removeBookmark: (state, action: PayloadAction<number>) => {
            state.bookmarks = state.bookmarks.filter((bookmark) => bookmark !== action.payload);
            localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            allApis.endpoints.getApiV1ClientUserFavoritesGetUserFavoriteAdsIds.matchFulfilled,
            (state, action) => {
                const payload = action.payload as number[];
                state.bookmarks = payload;
                localStorage.setItem('bookmarks', JSON.stringify(state.bookmarks));
            },
        );
    },
});

export default bookmarksSlice.reducer;

export const selectBookmarks = (state: { bookmarksState: IBookmarksState }) => state.bookmarksState;

export const { addBookmark, removeBookmark } = bookmarksSlice.actions;
